/**
 * Which files are binary (kept as base64 in the local cache and written to vfs-service as raw bytes), by extension or
 * MIME type. SVG is an image but text: it stays editable.
 */
const BINARY_EXTENSIONS = new Set([
  // images
  'png', 'jpg', 'jpeg', 'gif', 'bmp', 'ico', 'webp', 'tiff', 'tif', 'avif',
  // documents
  'pdf', 'doc', 'docx', 'xls', 'xlsx', 'ppt', 'pptx', 'odt', 'ods',
  // archives
  'zip', 'tar', 'gz', 'tgz', 'rar', '7z', 'bz2', 'xz', 'jar',
  // media
  'mp3', 'mp4', 'avi', 'mov', 'wav', 'flac', 'ogg', 'webm', 'm4a',
  // executables and libraries
  'exe', 'dll', 'so', 'dylib', 'bin', 'wasm', 'class',
  // fonts
  'ttf', 'otf', 'woff', 'woff2', 'eot',
]);

const MIME_BY_EXTENSION = {
  png: 'image/png', jpg: 'image/jpeg', jpeg: 'image/jpeg', gif: 'image/gif', bmp: 'image/bmp', ico: 'image/x-icon',
  webp: 'image/webp', tif: 'image/tiff', tiff: 'image/tiff', avif: 'image/avif', svg: 'image/svg+xml',
  pdf: 'application/pdf', zip: 'application/zip', gz: 'application/gzip', wasm: 'application/wasm',
  mp3: 'audio/mpeg', wav: 'audio/wav', ogg: 'audio/ogg', mp4: 'video/mp4', webm: 'video/webm', mov: 'video/quicktime',
  woff: 'font/woff', woff2: 'font/woff2', ttf: 'font/ttf', otf: 'font/otf',
  docx: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  pptx: 'application/vnd.openxmlformats-officedocument.presentationml.presentation',
};

const extensionOf = (fileName) => {
  const name = String(fileName || '').split('/').pop();
  return name.includes('.') ? name.split('.').pop().toLowerCase() : '';
};

export function isBinaryFile(fileName, mimeType = '') {
  if (BINARY_EXTENSIONS.has(extensionOf(fileName))) { return true; }
  if (!mimeType || mimeType === 'image/svg+xml') { return false; }
  return mimeType.startsWith('image/') || mimeType.startsWith('audio/') || mimeType.startsWith('video/')
    || mimeType === 'application/pdf' || mimeType === 'application/zip' || mimeType === 'application/octet-stream'
    || mimeType.includes('font');
}

export function mimeTypeFor(fileName) {
  return MIME_BY_EXTENSION[extensionOf(fileName)] || 'application/octet-stream';
}

/** Bytes → base64, in chunks (a spread of a large array overflows the call stack). */
export function bytesToBase64(bytes) {
  const view = bytes instanceof Uint8Array ? bytes : new Uint8Array(bytes);
  let binary = '';
  for (let offset = 0; offset < view.length; offset += 0x8000) {
    binary += String.fromCharCode.apply(null, view.subarray(offset, offset + 0x8000));
  }
  return btoa(binary);
}
